
import { supabase } from '@/lib/supabase'

export const resetPassword = async (email: string) => {
  try {
    const redirectTo = window.location.origin + '/reset-password'
    console.log('URL de redirection pour réinitialisation:', redirectTo)
    
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo
    })
    
    if (error) {
      console.error('Erreur lors de la réinitialisation du mot de passe:', error)
      throw error
    }
    
    return { data: true, error: null }
  } catch (error) {
    console.error('Exception lors de la réinitialisation du mot de passe:', error)
    return { data: null, error }
  }
}

export const updatePassword = async (password: string) => {
  try {
    const { error } = await supabase.auth.updateUser({
      password
    })
    
    if (error) {
      console.error('Erreur lors de la mise à jour du mot de passe:', error)
      throw error
    }
    
    return { data: true, error: null }
  } catch (error) {
    console.error('Exception lors de la mise à jour du mot de passe:', error)
    return { data: null, error }
  }
}
